import axios from "axios";
import { formatDate } from "utils/date";
import { buildQuery } from "utils/queryUtils";

export const findSendOTPs = (headers, params) => {
    let query = buildQuery(params, ["idNumber"]);
    if (params.filters.fromDate.value) {
        query += `&fromDate=${formatDate(params.filters.fromDate.value)}`;
    }
    if (params.filters.toDate.value) {
        query += `&toDate=${formatDate(params.filters.toDate.value)}`;
    }
    if (params.filters.userType.value) {
        query += `&userType=${params.filters.userType.value}`;
    }
    if (params.filters.idNumber.value) {
        query += `&idNumber=${params.filters.idNumber.value}`;
    }
    if (params.filters.method.value) {
        query += `&method=${params.filters.method.value}`;
    }
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/send-otp/search${query}`, {
        headers,
    });
};
